"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._normalizeUserDataResponses = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ampApi = require("@amplify/amp-api");

var _realtimeService = _interopRequireDefault(require("./realtimeService"));

var _constants = require("../shared/constants");

/**
 * This service provides methods for publishing and syncing updates
 * to shared-storage-service to support student-student data sharing
 * For jsdoc of core functions see index.js
 */

/**
 * Normalize user data responses into the form we send to the client
 */
var normalizeUserDataResponses = function normalizeUserDataResponses(userResponses, userKeys, prefix) {
  var normalizedData = [];
  userResponses.forEach(function (responses, i) {
    var userKey = userKeys[i];
    Object.entries(responses).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          fileKey = _ref2[0],
          data = _ref2[1];

      var normalizedFileKey = fileKey.replace(prefix, '');
      normalizedData.push({
        userKey: userKey,
        fileKey: normalizedFileKey,
        data: data
      });
    });
  });
  return normalizedData;
};

exports._normalizeUserDataResponses = normalizeUserDataResponses;

var SharedDataService = /*#__PURE__*/function () {
  function SharedDataService() {
    (0, _classCallCheck2.default)(this, SharedDataService);
    (0, _defineProperty2.default)(this, "userId", void 0);
  }

  (0, _createClass2.default)(SharedDataService, [{
    key: "init",
    value: function init(userId) {
      this.userId = userId;
    }
  }, {
    key: "publish",
    value: function () {
      var _publish = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(classKey, fileKey, data) {
        var userKey, realtimePayload;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userKey = this.userId;
                _context.next = 3;
                return (0, _ampApi.saveToSharedStorage)(classKey, userKey, fileKey, data);

              case 3:
                realtimePayload = {
                  classKey: classKey,
                  fileKey: fileKey,
                  userKey: userKey
                };
                return _context.abrupt("return", _realtimeService.default.publish(classKey, _constants.STUDENT_RECORD_TYPES.STUDENT_SHARED_DATA, realtimePayload));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function publish(_x, _x2, _x3) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "addListener",
    value: function () {
      var _addListener = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(classKey, prefix, callback) {
        var initialDataKeys, usersWithData, initialDataResponses, initialPayload, batchedNotifiedUsers, clearBatch, notificationCallback;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _ampApi.listSharedStorageByPrefix)(classKey, prefix);

              case 2:
                initialDataKeys = _context3.sent;

                if (!(initialDataKeys && initialDataKeys.length > 0)) {
                  _context3.next = 10;
                  break;
                }

                usersWithData = _lodash.default.uniq(_lodash.default.map(initialDataKeys, 'userKey'));
                _context3.next = 7;
                return Promise.all(usersWithData.map(function (userKey) {
                  return (0, _ampApi.fetchSharedStorageByUserAndPrefix)(classKey, userKey, prefix);
                }));

              case 7:
                initialDataResponses = _context3.sent;
                initialPayload = normalizeUserDataResponses(initialDataResponses, usersWithData, prefix);
                callback(initialPayload);

              case 10:
                // Track users to notify
                batchedNotifiedUsers = [];
                clearBatch = _lodash.default.throttle( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                  var currentUserBatch, userResponses, payload;
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          currentUserBatch = batchedNotifiedUsers;
                          batchedNotifiedUsers = [];
                          _context2.next = 4;
                          return Promise.all(currentUserBatch.map(function (userKey) {
                            return (0, _ampApi.fetchSharedStorageByUserAndPrefix)(classKey, userKey, prefix);
                          }));

                        case 4:
                          userResponses = _context2.sent;
                          payload = normalizeUserDataResponses(userResponses, currentUserBatch, prefix);
                          callback(payload);

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })), _constants.SHARED_STORAGE_BATCH_TIME);

                notificationCallback = function notificationCallback(channel, payload, publisher) {
                  // only handle notifications for this channel and prefix
                  if (channel !== classKey) return;
                  if (!payload.fileKey || !payload.fileKey.includes(prefix)) return;

                  if (!batchedNotifiedUsers.includes(publisher)) {
                    batchedNotifiedUsers.push(publisher);
                  }

                  clearBatch();
                };

                _realtimeService.default.addEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_SHARED_DATA, notificationCallback, callback);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function addListener(_x4, _x5, _x6) {
        return _addListener.apply(this, arguments);
      }

      return addListener;
    }()
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      _realtimeService.default.removeEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_SHARED_DATA, callback);
    }
  }]);
  return SharedDataService;
}();

var _default = new SharedDataService();

exports.default = _default;
//# sourceMappingURL=sharedDataService.js.map